<template>
    <div class="jump-warphd nav-bar-fixed">
        <van-nav-bar title="查看确认单" left-arrow fixed
                     @click-left="back"/>
        <van-row v-if="isShowInfo!=''" style="text-align: center;margin-top: 10px">
            {{isShowInfo}}
        </van-row>
        <van-row v-for="(item,index) in order">
            <van-row style="text-align: center;line-height: 30px;margin-top: 5px">确认单{{index+1}}</van-row>
            <van-cell title="客户名称" :value="item.custName"/>
            <van-cell title="业务员" :value="item.bussinessMan"/>
            <van-cell title="客户电话" :value="item.mobile"/>
            <van-cell title="回款方式" :value="item.payClass"/>
            <van-cell title="收货地址" :value="item.address"/>
            <van-cell title="备注" :value="item.remark"/>
            <van-cell title="订单号" :value="item.orderId"/>
            <van-cell title="出库单编号" :value="item.outNo"/>
            <van-cell title="订单时间" :value="item.createtime"/>
            <van-cell title="聚牧城账号" :value="item.userNo"/>
            <van-cell title="收货时间" :value="item.receiveTime"/>
            <van-cell title="车牌号" :value="item.plateNo"/>
            <van-collapse v-model="activeNames" class="pro-hd">
                <van-collapse-item title="商品明细" value="展开" name="2">
                    <div class="pro-item" v-for="good in item.goodList">
                        <van-cell title="品名" :value="good.goodsName"/>
                        <van-cell title="规格" :value="good.specificationDescription"/>
                        <van-cell title="单位" :value="good.goodsUnitSeller"/>
                        <van-cell title="数量" :value="good.count"/>
                        <van-cell title="单价(元)" :value="good.price"/>
                    </div>
                </van-collapse-item>
            </van-collapse>
            <p class="p-tol">合计金额(元):{{item.total | numFilter}}</p>
        </van-row>
    </div>
</template>
<script>
    import {NavBar, Cell, CellGroup, Field, Button, Row, Col, Collapse, CollapseItem} from "vant";

    export default {
        name: "userOrderArrival",
        components: {
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem
        },
        data() {
            return {
                activeNames: ["1"],
                orderId: this.$route.query.id,
                order: null,
                isShowInfo:''
            };
        }, mounted: function () {
            this.receiveCheck()

        },
        methods: {
            back() {
                history.back();
            }, receiveCheck() {
                let that = this
                that.$api.get(
                    that.jumuc.order.receiveCheck,
                    {"orderId": that.orderId},
                    successRes => {
                        if(successRes.data==null || successRes.data.length==0){
                            that.isShowInfo='暂无数据显示'
                        }
                        that.order = successRes.data
                    }
                )
            }
        }, filters: {
            numFilter(value) {
                // 截取当前数据到小数点后两位
                let realVal = parseFloat(value).toFixed(2)
                return realVal
            }
        },
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3C6EEB;

    .jump-warphd {
        .pro-hd {
            .van-collapse-item__title {
                background-color: #f7f7f7;
                color: @bule-thame;
                .van-cell__value, i {
                    color: @bule-thame;
                }
            }
        }
        .van-cell{
            padding: 3px 15px;
        }
        .van-collapse-item__content {
            padding: 0;
        }
        .pro-item {
            border-bottom: 5px solid #f7f7f7;
        }
        .p-tol {
            padding: 10px 10px 20px;
            color: @bule-thame;
            font-size: 14px;
            text-align: right;
        }
        .van-hairline--top-bottom::after {
            border-width: 0;
        }
        .van-cell:not(:last-child)::after {
            border: none;
        }
    }
</style>
